import React from 'react';
import NavButton from '../../components/ul/NavButton';

const Policy_Navbar = ({ onClick, label, className, icon, btnSave, selectState }) => {
    return (
        <nav className="text-main-font w-full p-2 sm:p-4">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-0">
                <div className='flex flex-wrap gap-2 sm:gap-4'>
                    <ul className="flex space-x-2 sm:space-x-4">
                        <li>
                            <NavButton
                                to="/site/policy"
                                btnName="Privacy Policy"
                                selectState={selectState === "policy"}
                            />
                        </li>
                    </ul>
                </div>
                <div className='w-full sm:w-auto'>
                    <button
                        onClick={onClick}
                        className={`${className} w-full sm:w-auto flex justify-center sm:justify-start`}
                        btnSave={btnSave}
                    >
                        <div className='flex items-center'>
                            {icon} <span className="ml-2">{label}</span>
                        </div>
                    </button>
                </div>
            </div>
        </nav>
    );
};

export default Policy_Navbar;